import { Routes } from '@/models/router/router.interface';
import store from '@/store';

export default class SelectedDashboardCode {

	public goToOverview(): void {
		store.mutations.setCurrentRoute(Routes.OVERVIEW);
	}
}
